// converts hello_world -> Hello World
const convertSnakeCaseToTitleCase = (input: string) => {
  const splitInput = input.split('_');
  const capitalizedInput = splitInput.map(word => word.charAt(0).toUpperCase() + word.slice(1));
  return capitalizedInput.join(' ');
};

export default convertSnakeCaseToTitleCase;
